<template>
  <div class="auth-wrapper auth-v1 px-2 dom-parcours" style="background-color:white;">
    <div class="py-2">
      <b-img
        class="m-2"
        center
        :src="require('@/assets/images/logo/DOMICIALIZ-LOGO.png')"
      />

      <!-- ========================================= -->
      <!-- ÉTAPE 0 : Landing / Accueil société       -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 0">
        <div class="h1 text-center dom-titre-vert" style="font-size: 53px;font-weight: 700;">
          Bienvenue{{ libsocAffiche ? ` chez ${libsocAffiche}` : '' }}
        </div>
        <br>
        <b-card>
          <div class="h4 font-weight-bolder text-uppercase text-center">
            Obtenir ma domiciliation
          </div>
          <hr>
          <p class="text-center">
            Besoin d'une Domiciliation de Siège Social et Domiciliation Postale ?
            {{ libsocAffiche || 'Domicializ' }} vous accompagne.
          </p>
          <p class="text-center">
            Une adresse adaptée à vos besoins, une gestion simplifiée de votre courrier
            et un parcours 100 % en ligne. Votre domiciliation n'a jamais été aussi simple.
          </p>
          <div class="text-center mt-3">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="lg"
              @click="etapeencour = 1"
            >
              Commencer ma domiciliation
            </b-button>
          </div>
        </b-card>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 1 : Informations personnelles       -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 1">
        <b-card>
          <div class="h4 font-weight-bolder text-uppercase">
            Informations personnelles
          </div>
          <hr>

          <!-- Type de client -->
          <b-form-group label="Vous êtes *">
            <b-form-radio-group
              v-model="typeClient"
              :options="optionsTypeClient"
              buttons
              button-variant="outline-primary"
            />
          </b-form-group>

          <!-- Sous-options pour Entreprise / Association -->
          <div v-if="typeClient === 'entreprise' || typeClient === 'association'">
            <b-form-group label="Situation">
              <b-form-radio-group
                v-model="situationPro"
                :options="optionsSituation"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>

            <!-- Sous-options si déjà en activité -->
            <div v-if="situationPro === 'activite'">
              <b-form-group label="Type de demande">
                <b-form-radio-group
                  v-model="typeDemande"
                  :options="optionsTypeDemandeAffiche"
                  buttons
                  button-variant="outline-secondary"
                />
              </b-form-group>
            </div>
          </div>

          <hr>
          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Prénom *"
                label-for="dom-prenom"
                label-cols-md="3"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="CPRENOM"
                    id="dom-prenom"
                    placeholder="Prénom"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Nom *"
                label-for="dom-nom"
                label-cols-md="3"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="CNOM"
                    id="dom-nom"
                    placeholder="Nom"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="h5 font-weight-bolder text-uppercase mt-1">
            Contact
          </div>
          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Portable *"
                label-for="dom-port"
                label-cols-md="3"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SmartphoneIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="CPORT"
                    id="dom-port"
                    placeholder="06 00 00 00 00"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Adresse email *"
                label-for="dom-email"
                label-cols-md="3"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="CEMAIL"
                    id="dom-email"
                    type="email"
                    placeholder="email@exemple.com"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <small class="text-muted">
            *Votre numéro de portable et votre email sont indispensables pour que nous
            puissions vous recontacter et valider votre dossier de domiciliation.
          </small>

          <hr>
          <div v-if="!demandeCreee" class="text-right">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="validerEtape1"
            >
              Commencer ma domiciliation
            </b-button>
          </div>

          <!-- Vérification email -->
          <div v-if="demandeCreee && !bcodeok">
            <hr>
            <div class="h5">
              Par mesure de sécurité, merci de saisir le code reçu par e-mail
            </div>
            <b-row>
              <b-col cols="6">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="CEMAIL"
                    type="email"
                    placeholder="Email"
                  />
                </b-input-group>
              </b-col>
              <b-col cols="6">
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  @click="sendcode"
                >
                  Renvoyer le code
                </b-button>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col cols="3">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="ShieldIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="CCODE"
                    placeholder="0000"
                  />
                </b-input-group>
              </b-col>
              <b-col cols="6" class="text-left">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="verifcode"
                >
                  Valider et choisir mon offre
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 2 : Choix de la formule             -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 2">
        <div class="h1 text-center text-dark text-uppercase" style="font-size: 40px;font-weight: 700;">
          Choisissez votre formule
        </div>
        <br>

        <!-- Toggle facturation -->
        <div class="text-center mb-2">
          <b-form-radio-group
            v-model="facturation"
            :options="optionsFacturation"
            buttons
            button-variant="outline-primary"
          />
        </div>

        <!-- Cartes formules -->
        <b-card-group deck>
          <b-card
            v-for="formule in formules"
            :key="formule.id"
            :border-variant="formule.badge ? 'primary' : 'secondary'"
            class="text-center"
          >
            <!-- Badge "Le + complet" (hauteur réservée pour aligner les titres) -->
            <div class="dom-formule-badge mb-1">
              <b-badge v-if="formule.badge" variant="primary">{{ formule.badge }}</b-badge>
            </div>

            <div class="dom-formule-titre">
              <div class="dom-formule-pack font-weight-bolder">
                {{ formule.pack }}
              </div>
              <!-- Accroche pilotée par l'admin (/admin-dom/formules) : elle fait
                   autorité, y compris vide — aucun texte de repli. -->
              <div class="dom-formule-benefice text-muted">
                {{ formule.benefice }}
              </div>
            </div>

            <div class="h2 font-weight-bolder dom-formule-prix my-1">
              {{ getPrix(formule) }}&euro; <small class="text-muted">HT/mois</small>
            </div>

            <!-- Badge promotionnel réservé à la facturation annuelle.
                 La ligne n'est réservée que si au moins une formule affichée
                 porte un badge, pour que les cartes restent alignées. -->
            <div v-if="afficherBadgePromoAnnuel" class="dom-formule-promo mb-1">
              <b-badge v-if="formule.badgeAnnuel" class="dom-badge-promo px-1">
                <feather-icon
                  icon="GiftIcon"
                  size="14"
                  class="mr-25"
                />
                {{ formule.badgeAnnuel }}
              </b-badge>
            </div>

            <hr>

            <!-- Features -->
            <ul class="list-unstyled text-left px-2">
              <li v-for="(feat, index) in formule.features" :key="index" class="mb-50">
                <feather-icon
                  :icon="feat.inclus ? 'CheckIcon' : 'XIcon'"
                  :class="feat.inclus ? 'text-success' : 'text-danger'"
                  size="16"
                />
                {{ feat.libelle }}
              </li>
            </ul>

            <hr>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              @click="souscrireFormule(formule)"
            >
              Souscrire
            </b-button>
          </b-card>
        </b-card-group>

        <b-card class="mt-1">
          <b-row>
            <b-col class="text-left">
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-primary"
                @click="etapeencour = 1"
              >
                Précédent
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 3 : Informations établissement      -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 3">
        <div class="h1 text-center text-dark text-uppercase" style="font-size: 40px;font-weight: 700;">
          Informations sur l'établissement à domicilier
        </div>
        <p class="text-center text-muted">
          Ces renseignements sont essentiels pour établir votre contrat
        </p>
        <br>

        <b-row>
          <!-- Formulaire col-8 -->
          <b-col cols="12" md="8">
            <b-card>
              <b-form @submit.prevent>
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Raison Sociale *"
                      label-for="dom-rs"
                      label-cols-md="4"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="HomeIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="raisonSociale"
                          id="dom-rs"
                          placeholder="Raison sociale"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Forme juridique *"
                      label-for="dom-fj"
                      label-cols-md="5"
                    >
                      <v-select
                        id="dom-fj"
                        v-model="formeJuridique"
                        label="name"
                        placeholder="Choisissez votre forme juridique"
                        :options="formesJuridiques"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Capital Social *"
                      label-for="dom-capital"
                      label-cols-md="5"
                    >
                      <b-input-group class="input-group-merge" append="€">
                        <b-form-input
                          v-model="capitalSocial"
                          id="dom-capital"
                          placeholder="Montant en €"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Objet social"
                      label-for="dom-objet"
                      label-cols-md="3"
                    >
                      <b-form-input
                        v-model="objetSocial"
                        id="dom-objet"
                        placeholder="Objet social"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Code APE"
                      label-for="dom-ape"
                      label-cols-md="5"
                    >
                      <b-form-input
                        v-model="codeAPE"
                        id="dom-ape"
                        placeholder="Code APE"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Activité exercée"
                      label-for="dom-activite"
                      label-cols-md="5"
                    >
                      <b-form-input
                        v-model="activiteExercee"
                        id="dom-activite"
                        placeholder="Activité exercée"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Identifiant des structures déjà existantes -->
                <b-row v-if="typeClient === 'entreprise' && situationPro === 'activite'">
                  <b-col cols="6">
                    <b-form-group
                      label="SIRET *"
                      label-for="dom-siret"
                      label-cols-md="5"
                    >
                      <b-form-input
                        v-model="siret"
                        id="dom-siret"
                        placeholder="N° SIRET"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="typeClient === 'association' && situationPro === 'activite'">
                  <b-col cols="6">
                    <b-form-group
                      label="N° RNA *"
                      label-for="dom-rna"
                      label-cols-md="5"
                    >
                      <b-form-input
                        v-model="rna"
                        id="dom-rna"
                        placeholder="W000000000"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <hr>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Email professionnel"
                      label-for="dom-emailpro"
                      label-cols-md="5"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="MailIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="emailPro"
                          id="dom-emailpro"
                          type="email"
                          placeholder="Si différent de votre email personnel"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Numéro professionnel"
                      label-for="dom-telpro"
                      label-cols-md="5"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="PhoneIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="telPro"
                          id="dom-telpro"
                          placeholder="Si différent de votre numéro personnel"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <hr>
                <b-form-group label="Avez-vous des associés ?">
                  <small class="text-muted d-block mb-1">Concerne uniquement les associés ayant plus de 25% des parts</small>
                  <b-form-radio-group
                    v-model="aDesAssocies"
                    :options="[{ text: 'Non', value: false }, { text: 'Oui', value: true }]"
                    buttons
                    button-variant="outline-primary"
                  />
                </b-form-group>

                <!-- Liste des associés -->
                <div v-if="aDesAssocies">
                  <div v-for="(associe, index) in associes" :key="index" class="mb-1">
                    <b-row>
                      <b-col cols="4">
                        <b-form-input
                          v-model="associe.prenom"
                          placeholder="Prénom"
                        />
                      </b-col>
                      <b-col cols="4">
                        <b-form-input
                          v-model="associe.nom"
                          placeholder="Nom"
                        />
                      </b-col>
                      <b-col cols="3">
                        <b-input-group append="%">
                          <b-form-input
                            v-model="associe.pourcentageParts"
                            placeholder="Parts"
                            type="number"
                          />
                        </b-input-group>
                      </b-col>
                      <b-col cols="1">
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="associes.splice(index, 1)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="associes.push({ nom: '', prenom: '', pourcentageParts: '' })"
                  >
                    + Ajouter un associé
                  </b-button>
                </div>
              </b-form>

              <hr>
              <b-row>
                <b-col class="text-left">
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-primary"
                    @click="etapeencour = 2"
                  >
                    Précédent
                  </b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="validerEtape3"
                  >
                    Suivant
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <!-- Récapitulatif col-4 -->
          <b-col cols="12" md="4">
            <b-card class="border-primary">
              <div class="h5 font-weight-bolder text-center">Récapitulatif de votre demande</div>
              <hr>
              <div class="text-center mb-1">
                <b-badge variant="primary" class="px-2 py-1">{{ formuleChoisie ? formuleChoisie.pack : '' }}</b-badge>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>1er mois d'abonnement</span>
                <strong>{{ prixTTC }}&euro; TTC</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>{{ nbMoisDepot }} mois de dépôt de garantie*</span>
                <strong>{{ depotGarantie }}&euro;</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>Frais de dossier</span>
                <strong>20&euro; TTC</strong>
              </div>
              <hr>
              <div v-if="showPromo">
                <b-form-group label="Code promo" label-for="dom-promo">
                  <b-form-input
                    v-model="codePromo"
                    id="dom-promo"
                    placeholder="Entrez votre code"
                    size="sm"
                  />
                </b-form-group>
              </div>
              <a href="#" class="small" @click.prevent="showPromo = !showPromo">
                Ajouter un code promo
              </a>
              <hr>
              <small class="text-muted d-block mb-1">*le dépôt de garantie vous sera restitué après votre contrat conformément à nos CGV</small>
              <div class="d-flex justify-content-between">
                <span class="h5 font-weight-bolder">Total</span>
                <span class="h5 font-weight-bolder text-primary">{{ totalTTC }}&euro; TTC</span>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 4 : Informations représentant légal -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 4">
        <div class="h1 text-center text-dark text-uppercase" style="font-size: 40px;font-weight: 700;">
          {{ titreRepresentant }}
        </div>
        <p class="text-center text-muted">
          Ces renseignements sont essentiels pour établir votre contrat
        </p>
        <br>

        <b-row>
          <!-- Formulaire col-8 -->
          <b-col cols="12" md="8">
            <b-card>
              <b-form @submit.prevent>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Qualité *"
                      label-for="dom-qualite"
                      label-cols-md="4"
                    >
                      <b-form-input
                        v-model="qualite"
                        id="dom-qualite"
                        placeholder="Gérant, Président, Associé..."
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Civilité *"
                      label-for="dom-civrl"
                      label-cols-md="4"
                    >
                      <v-select
                        id="dom-civrl"
                        v-model="civiliteRL"
                        label="name"
                        placeholder="Choisir une civilité"
                        :options="civilites"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Prénom *"
                      label-for="dom-prenomrl"
                      label-cols-md="4"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="UserIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="prenomRL"
                          id="dom-prenomrl"
                          placeholder="Prénom"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Nom *"
                      label-for="dom-nomrl"
                      label-cols-md="4"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="UserIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="nomRL"
                          id="dom-nomrl"
                          placeholder="Nom"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Portable *"
                      label-for="dom-portrl"
                      label-cols-md="4"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="SmartphoneIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="portableRL"
                          id="dom-portrl"
                          placeholder="06 00 00 00 00"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Adresse email *"
                      label-for="dom-emailrl"
                      label-cols-md="4"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="MailIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="emailRL"
                          id="dom-emailrl"
                          type="email"
                          placeholder="email@exemple.com"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <hr>
                <div class="h5 font-weight-bolder text-uppercase">Naissance</div>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Date de naissance *"
                      label-for="dom-datenais"
                      label-cols-md="5"
                    >
                      <b-form-input
                        v-model="dateNaissance"
                        id="dom-datenais"
                        type="date"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      label="Ville de naissance *"
                      label-for="dom-villenais"
                    >
                      <b-form-input
                        v-model="villeNaissance"
                        id="dom-villenais"
                        placeholder="Ville de naissance"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group
                      label="Département de naissance"
                      label-for="dom-deptnais"
                    >
                      <b-form-input
                        v-model="deptNaissance"
                        id="dom-deptnais"
                        placeholder="Département de naissance"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group
                      label="Pays de naissance"
                      label-for="dom-paysnais"
                    >
                      <b-form-input
                        v-model="paysNaissance"
                        id="dom-paysnais"
                        placeholder="Pays de naissance"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <hr>
                <div class="h5 font-weight-bolder text-uppercase">Adresse personnelle</div>
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Numéro et nom de rue *"
                      label-for="dom-adresse"
                      label-cols-md="3"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="MapPinIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="adresseRL"
                          id="dom-adresse"
                          placeholder="20 Rue de la Gare..."
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Complément d'adresse"
                      label-for="dom-complement"
                      label-cols-md="3"
                    >
                      <b-form-input
                        v-model="complementAdresse"
                        id="dom-complement"
                        placeholder="Numéro de bâtiment..."
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      label="Code postal *"
                      label-for="dom-cprl"
                    >
                      <b-form-input
                        v-model="cpRL"
                        id="dom-cprl"
                        placeholder="97400..."
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group
                      label="Ville *"
                      label-for="dom-villerl"
                    >
                      <b-form-input
                        v-model="villeRL"
                        id="dom-villerl"
                        placeholder="Saint Denis..."
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group
                      label="Pays *"
                      label-for="dom-paysrl"
                    >
                      <b-form-input
                        v-model="paysRL"
                        id="dom-paysrl"
                        placeholder="Réunion"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <hr>
                <b-form-group label="Êtes-vous résident fiscal dans un autre pays que la France ?">
                  <small class="text-muted d-block mb-1">Si oui, merci d'indiquer quel pays</small>
                  <b-form-radio-group
                    v-model="residentFiscalEtranger"
                    :options="[{ text: 'Non', value: false }, { text: 'Oui', value: true }]"
                    buttons
                    button-variant="outline-primary"
                  />
                  <b-form-input
                    v-if="residentFiscalEtranger"
                    v-model="paysResidenceFiscale"
                    class="mt-1"
                    placeholder="Pays de résidence fiscale"
                  />
                </b-form-group>

                <template v-if="typeClient !== 'particulier'">
                <hr>
                <div class="h5 font-weight-bolder text-uppercase">Localisation des archives</div>
                <small class="text-muted d-block mb-1">
                  Adresse où sont conservés vos documents administratifs, comptables et juridiques (article R123-168-1 du Code de commerce).
                </small>
                <b-form-group label="Type de lieu *">
                  <b-form-radio-group
                    v-model="archivesTypeLieu"
                    :options="optionsArchivesTypeLieu"
                    buttons
                    button-variant="outline-primary"
                    @change="onChangeArchivesTypeLieu"
                  />
                  <b-form-input
                    v-if="archivesTypeLieu === 'autre'"
                    v-model="archivesTypeLieuAutre"
                    class="mt-1"
                    placeholder="Précisez"
                  />
                </b-form-group>
                <b-row>
                  <b-col cols="12" :md="archivesFonctionAffichee ? 6 : 12">
                    <b-form-group label="Personne en charge des archives">
                      <b-form-input v-model="archivesResponsable" placeholder="Nom et prénom" />
                    </b-form-group>
                  </b-col>
                  <b-col v-if="archivesFonctionAffichee" cols="12" md="6">
                    <b-form-group label="Fonction">
                      <b-form-input v-model="archivesFonction" placeholder="Ex. expert-comptable, dirigeant" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="8">
                    <b-form-group label="Adresse *">
                      <b-form-input v-model="archivesAdresse" placeholder="Adresse" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="Complément">
                      <b-form-input v-model="archivesComplement" placeholder="Bât. / étage" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="Code postal *">
                      <b-form-input v-model="archivesCp" placeholder="97400" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="5">
                    <b-form-group label="Ville *">
                      <b-form-input v-model="archivesVille" placeholder="Ville" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Pays">
                      <b-form-input v-model="archivesPays" placeholder="France" />
                    </b-form-group>
                  </b-col>
                </b-row>
                </template>

                <hr>
                <div class="h5 font-weight-bolder text-uppercase">Lutte contre le blanchiment (LCB-FT)</div>
                <small class="text-muted d-block mb-1">
                  Informations requises par l'article L561-10 du Code monétaire et financier.
                </small>

                <b-form-group label="Êtes-vous une personne politiquement exposée (PPE) ?">
                  <small class="text-muted d-block mb-1">
                    Si non, votre attestation de déclaration sur l'honneur sera automatiquement remplie.
                  </small>
                  <b-form-radio-group
                    v-model="personneExposee"
                    :options="[{ text: 'Non', value: false }, { text: 'Oui', value: true }]"
                    buttons
                    button-variant="outline-primary"
                  />
                </b-form-group>

                <div v-if="personneExposee" class="pl-1 border-left border-primary">
                  <b-form-group label="Catégorie PPE *">
                    <b-form-radio-group
                      v-model="ppeCategorie"
                      :options="optionsPpeCategorie"
                      stacked
                    />
                    <b-form-input
                      v-if="ppeCategorie === 'autre'"
                      v-model="ppeCategorieAutre"
                      class="mt-1"
                      placeholder="Précisez"
                    />
                  </b-form-group>

                  <b-form-group label="Avez-vous un lien familial ou professionnel avec une PPE ?">
                    <b-form-radio-group
                      v-model="ppeLien"
                      :options="[{ text: 'Non', value: false }, { text: 'Oui', value: true }]"
                      buttons
                      button-variant="outline-primary"
                    />
                  </b-form-group>

                  <div v-if="ppeLien">
                    <b-form-group label="Nature du lien *">
                      <b-form-radio-group
                        v-model="ppeLienType"
                        :options="optionsPpeLienType"
                      />
                      <b-form-input
                        v-if="ppeLienType === 'autre'"
                        v-model="ppeLienAutre"
                        class="mt-1"
                        placeholder="Précisez"
                      />
                    </b-form-group>
                    <b-row>
                      <b-col cols="4">
                        <b-form-group label="Nom de la PPE">
                          <b-form-input v-model="ppeLienNom" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="4">
                        <b-form-group label="Fonction exercée">
                          <b-form-input v-model="ppeLienFonction" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="4">
                        <b-form-group label="Pays d'exercice">
                          <b-form-input v-model="ppeLienPays" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <template v-if="typeClient !== 'particulier'">
                <hr>
                <b-form-group label="Source principale des fonds utilisés *">
                  <b-form-radio-group
                    v-model="origineFonds"
                    :options="optionsOrigineFonds"
                  />
                  <b-form-input
                    v-if="origineFonds === 'autre'"
                    v-model="origineFondsAutre"
                    class="mt-1"
                    placeholder="Précisez"
                  />
                </b-form-group>
                <b-form-group label="Pays d'origine des fonds">
                  <b-form-input v-model="origineFondsPays" placeholder="France" />
                </b-form-group>
                </template>

                <b-form-group label="Activités dans des pays à risque (sanctionnés ou à haut risque selon le GAFI) ?">
                  <b-form-radio-group
                    v-model="paysRisqueGafi"
                    :options="[{ text: 'Non', value: false }, { text: 'Oui', value: true }]"
                    buttons
                    button-variant="outline-primary"
                  />
                  <b-form-input
                    v-if="paysRisqueGafi"
                    v-model="paysRisqueGafiPrecisions"
                    class="mt-1"
                    placeholder="Précisez le(s) pays"
                  />
                </b-form-group>

                <b-form-group label="Mesure de gel des avoirs en cours (européenne ou nationale) ?">
                  <b-form-radio-group
                    v-model="gelAvoirs"
                    :options="[{ text: 'Non', value: false }, { text: 'Oui', value: true }]"
                    buttons
                    button-variant="outline-primary"
                  />
                  <b-form-textarea
                    v-if="gelAvoirs"
                    v-model="gelAvoirsPrecisions"
                    class="mt-1"
                    placeholder="Nature, date, autorité décisionnaire, personnes concernées"
                    rows="2"
                  />
                </b-form-group>

                <b-form-group label="Poursuites ou sanctions dans les 5 dernières années ?">
                  <b-form-radio-group
                    v-model="proceduresJudiciaires"
                    :options="[{ text: 'Non', value: false }, { text: 'Oui', value: true }]"
                    buttons
                    button-variant="outline-primary"
                  />
                  <b-form-textarea
                    v-if="proceduresJudiciaires"
                    v-model="proceduresJudiciairesPrecisions"
                    class="mt-1"
                    placeholder="Nature, date, issue"
                    rows="2"
                  />
                </b-form-group>

                <!-- La saisie de l'IBAN a été retirée de cette étape le 16/10/2026 :
                     le prélèvement passe désormais par le mandat GoCardless, signé
                     par le client à l'étape 8 sur une page sécurisée. Les colonnes
                     C_sepa* restent en base pour les dossiers antérieurs. -->
                <hr>
                <b-form-group label="Commentaire">
                  <b-form-textarea
                    v-model="commentaire"
                    placeholder="Commentaire libre..."
                    rows="3"
                  />
                </b-form-group>
              </b-form>

              <hr>
              <b-row>
                <b-col class="text-left">
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-primary"
                    @click="etapeencour = typeClient === 'particulier' ? 2 : 3"
                  >
                    Précédent
                  </b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="validerEtape4"
                  >
                    Suivant
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <!-- Récapitulatif col-4 -->
          <b-col cols="12" md="4">
            <b-card class="border-primary">
              <div class="h5 font-weight-bolder text-center">Récapitulatif de votre demande</div>
              <hr>
              <div class="text-center mb-1">
                <b-badge variant="primary" class="px-2 py-1">{{ formuleChoisie ? formuleChoisie.pack : '' }}</b-badge>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>1er mois d'abonnement</span>
                <strong>{{ prixTTC }}&euro; TTC</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>{{ nbMoisDepot }} mois de dépôt de garantie*</span>
                <strong>{{ depotGarantie }}&euro;</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>Frais de dossier</span>
                <strong>20&euro; TTC</strong>
              </div>
              <hr>
              <small class="text-muted d-block mb-1">*le dépôt de garantie vous sera restitué après votre contrat conformément à nos CGV</small>
              <div class="d-flex justify-content-between">
                <span class="h5 font-weight-bolder">Total</span>
                <span class="h5 font-weight-bolder text-primary">{{ totalTTC }}&euro; TTC</span>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 5 : Dépôt des pièces justificatives -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 5">
        <div class="h1 text-center dom-titre-vert" style="font-size: 40px;font-weight: 700;">
          Dépôts des pièces justificatives
        </div>
        <p class="text-center text-muted">
          Les documents que vous transmettez sont traités de manière strictement confidentielle, sécurisée et uniquement pour les besoins légaux de la domiciliation, conformément au RGPD.
        </p>
        <br>

        <b-row>
          <!-- Upload zone col-8 -->
          <b-col cols="12" md="8">
            <b-card>
              <!-- Justificatifs personnels -->
              <template v-if="documentsPersonnels.length">
              <div class="h5 font-weight-bolder text-uppercase">Justificatifs personnels</div>
              <hr>
              </template>
              <div v-for="doc in documentsPersonnels" :key="doc.UI" class="mb-2">
                <label class="font-weight-bold">{{ doc.libelle }}{{ doc.obligatoire ? ' *' : '' }}</label>
                <!-- Fichier déjà uploadé -->
                <div v-if="documentsUploades[doc.UI]" class="d-flex align-items-center mb-50">
                  <feather-icon icon="CheckCircleIcon" class="text-success mr-50" size="16" />
                  <span class="text-success mr-1">{{ documentsUploades[doc.UI].nomOriginal }}</span>
                  <small class="text-muted mr-1">({{ formatTaille(documentsUploades[doc.UI].taille) }})</small>
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="supprimerDocument(doc.UI)"
                  >
                    <feather-icon icon="TrashIcon" size="14" />
                  </b-button>
                </div>
                <!-- Upload -->
                <div v-else>
                  <b-form-file
                    :ref="'file-' + doc.UI"
                    placeholder="Choisir un fichier ou glisser-déposer..."
                    drop-placeholder="Déposer le fichier ici..."
                    browse-text="Parcourir"
                    accept=".pdf,.jpg,.jpeg,.png,.webp"
                    @input="uploadDocument(doc.UI, $event)"
                  />
                  <b-progress
                    v-if="uploadEnCours[doc.UI]"
                    :value="100"
                    animated
                    variant="primary"
                    class="mt-50"
                    style="height: 5px;"
                  />
                </div>
                <small v-if="doc.description" class="text-muted">{{ doc.description }}</small>
              </div>

              <!-- Justificatifs professionnels -->
              <template v-if="documentsProfessionnels.length">
              <hr>
              <div class="h5 font-weight-bolder text-uppercase">Justificatifs professionnels</div>
              <hr>
              </template>
              <div v-for="doc in documentsProfessionnels" :key="doc.UI" class="mb-2">
                <label class="font-weight-bold">{{ doc.libelle }}{{ doc.obligatoire ? ' *' : '' }}</label>
                <!-- Fichier déjà uploadé -->
                <div v-if="documentsUploades[doc.UI]" class="d-flex align-items-center mb-50">
                  <feather-icon icon="CheckCircleIcon" class="text-success mr-50" size="16" />
                  <span class="text-success mr-1">{{ documentsUploades[doc.UI].nomOriginal }}</span>
                  <small class="text-muted mr-1">({{ formatTaille(documentsUploades[doc.UI].taille) }})</small>
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="supprimerDocument(doc.UI)"
                  >
                    <feather-icon icon="TrashIcon" size="14" />
                  </b-button>
                </div>
                <!-- Upload -->
                <div v-else>
                  <b-form-file
                    :ref="'file-' + doc.UI"
                    placeholder="Choisir un fichier ou glisser-déposer..."
                    drop-placeholder="Déposer le fichier ici..."
                    browse-text="Parcourir"
                    accept=".pdf,.jpg,.jpeg,.png,.webp"
                    @input="uploadDocument(doc.UI, $event)"
                  />
                  <b-progress
                    v-if="uploadEnCours[doc.UI]"
                    :value="100"
                    animated
                    variant="primary"
                    class="mt-50"
                    style="height: 5px;"
                  />
                </div>
                <small v-if="doc.description" class="text-muted">{{ doc.description }}</small>
              </div>

              <hr>
              <b-row>
                <b-col class="text-left">
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-primary"
                    @click="etapeencour = 4"
                  >
                    Précédent
                  </b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="validerEtape5"
                  >
                    Suivant
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <!-- Récapitulatif col-4 -->
          <b-col cols="12" md="4">
            <b-card class="border-primary">
              <div class="h5 font-weight-bolder text-center">Récapitulatif de votre demande</div>
              <hr>
              <div class="text-center mb-1">
                <b-badge variant="primary" class="px-2 py-1">{{ formuleChoisie ? formuleChoisie.pack : '' }}</b-badge>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>1er mois d'abonnement</span>
                <strong>{{ prixTTC }}&euro; TTC</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>{{ nbMoisDepot }} mois de dépôt de garantie*</span>
                <strong>{{ depotGarantie }}&euro;</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>Frais de dossier</span>
                <strong>20&euro; TTC</strong>
              </div>
              <hr>
              <small class="text-muted d-block mb-1">*le dépôt de garantie vous sera restitué après votre contrat conformément à nos CGV</small>
              <div class="d-flex justify-content-between">
                <span class="h5 font-weight-bolder">Total</span>
                <span class="h5 font-weight-bolder text-primary">{{ totalTTC }}&euro; TTC</span>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 6 : Relecture des documents         -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 6">
        <div class="h1 text-center dom-titre-vert" style="font-size: 40px;font-weight: 700;">
          Relecture des documents
        </div>
        <p class="text-center text-muted">
          Avant de passer à la signature des éléments, veuillez procéder à la relecture
        </p>
        <br>

        <b-row>
          <!-- Documents col-8 -->
          <b-col cols="12" md="8">
            <b-card>
              <b-list-group>
                <b-list-group-item
                  v-for="(doc, index) in documentsRelectureAffiche"
                  :key="index"
                  class="d-flex justify-content-between align-items-center"
                >
                  <div>
                    <feather-icon icon="FileTextIcon" class="mr-1 text-primary" />
                    {{ doc.label }}
                    <span v-if="doc.obligatoire" class="text-danger">*</span>
                  </div>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="ouvrirDocument(doc)"
                  >
                    <feather-icon icon="EyeIcon" class="mr-50" />
                    Consulter
                  </b-button>
                </b-list-group-item>
              </b-list-group>

              <hr>
              <b-form-checkbox
                v-model="accepteDocuments"
                name="check-button"
                switch
                inline
              >
                J'ai lu et j'accepte l'ensemble des documents ci-dessus. J'accepte que mes données soient utilisées exclusivement dans le cadre du traitement de ma demande de domiciliation, conformément au RGPD.
              </b-form-checkbox>

              <hr>
              <b-row>
                <b-col class="text-left">
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-primary"
                    @click="etapeencour = 5"
                  >
                    Précédent
                  </b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button
                    :disabled="!accepteDocuments"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="payerEtSigner"
                  >
                    Payer et signer
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <!-- Récapitulatif col-4 -->
          <b-col cols="12" md="4">
            <b-card class="border-primary">
              <div class="h5 font-weight-bolder text-center">Récapitulatif de votre demande</div>
              <hr>
              <div class="text-center mb-1">
                <b-badge variant="primary" class="px-2 py-1">{{ formuleChoisie ? formuleChoisie.pack : '' }}</b-badge>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>1er mois d'abonnement</span>
                <strong>{{ prixTTC }}&euro; TTC</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>{{ nbMoisDepot }} mois de dépôt de garantie*</span>
                <strong>{{ depotGarantie }}&euro;</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>Frais de dossier</span>
                <strong>20&euro; TTC</strong>
              </div>
              <hr>
              <small class="text-muted d-block mb-1">*le dépôt de garantie vous sera restitué après votre contrat conformément à nos CGV</small>
              <div class="d-flex justify-content-between">
                <span class="h5 font-weight-bolder">Total</span>
                <span class="h5 font-weight-bolder text-primary">{{ totalTTC }}&euro; TTC</span>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 7 : Paiement Stripe                 -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 7">
        <div class="h1 text-center dom-titre-vert" style="font-size: 40px;font-weight: 700;">
          Paiement
        </div>
        <p class="text-center text-muted">
          Payer votre 1ère mensualité et finaliser votre domiciliation
        </p>
        <br>

        <b-row>
          <b-col cols="12" md="8">
            <b-card v-if="stripeErreur">
              <div class="h6 font-weight-bolder">Erreur lors de la préparation du paiement</div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="preparerPaiement"
              >
                Relancer la demande
              </b-button>
            </b-card>

            <b-card v-if="stripePret">
              <div class="h6">Paiement de <strong>{{ montantPaiement }}&euro; TTC</strong></div>
              <stripe-element-payment
                ref="paymentRef"
                :pk="pk"
                :elements-options="elementsOptions"
                :confirm-params="confirmParams"
              />
              <br>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="pay"
              >
                Payer {{ montantPaiement }}&euro; TTC
              </b-button>
            </b-card>

            <b-card v-if="!stripePret && !stripeErreur">
              <div class="h6">Préparation du paiement...</div>
            </b-card>
          </b-col>

          <!-- Récapitulatif col-4 -->
          <b-col cols="12" md="4">
            <b-card class="border-primary">
              <div class="h5 font-weight-bolder text-center">Récapitulatif de votre demande</div>
              <hr>
              <div class="text-center mb-1">
                <b-badge variant="primary" class="px-2 py-1">{{ formuleChoisie ? formuleChoisie.pack : '' }}</b-badge>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>1er mois d'abonnement</span>
                <strong>{{ prixTTC }}&euro; TTC</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>{{ nbMoisDepot }} mois de dépôt de garantie*</span>
                <strong>{{ depotGarantie }}&euro;</strong>
              </div>
              <div class="d-flex justify-content-between mb-50">
                <span>Frais de dossier</span>
                <strong>20&euro; TTC</strong>
              </div>
              <hr>
              <small class="text-muted d-block mb-1">*le dépôt de garantie vous sera restitué après votre contrat conformément à nos CGV</small>
              <div class="d-flex justify-content-between">
                <span class="h5 font-weight-bolder">Total</span>
                <span class="h5 font-weight-bolder text-primary">{{ totalTTC }}&euro; TTC</span>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- ========================================= -->
      <!-- ÉTAPE 8 : Confirmation / Succès           -->
      <!-- ========================================= -->
      <div v-if="etapeencour == 8">
        <div class="text-center py-4">
          <feather-icon icon="CheckCircleIcon" size="80" class="text-success mb-2" />
          <div class="h1" style="font-size: 40px;font-weight: 700;color: #AAE7C0;">
            Votre domiciliation a été effectuée avec succès
          </div>
          <p class="text-muted mt-1">
            Notre équipe commerciale va prendre contact avec vous prochainement
          </p>
          <hr>
          <b-card class="text-left" style="max-width: 500px; margin: 0 auto;">
            <div class="d-flex justify-content-between mb-50">
              <span>Montant réglé ce jour</span>
              <strong class="text-primary">{{ totalTTC }}&euro; TTC</strong>
            </div>
            <hr>
            <small class="text-muted d-block">
              Une copie des documents vous a été transmise par email.<br>
              Votre attestation de domiciliation et vos factures vous seront envoyées par l'équipe commerciale.
            </small>
          </b-card>

          <!-- ===================================== -->
          <!-- Mandat de prélèvement SEPA            -->
          <!-- ===================================== -->
          <b-card
            v-if="mandatAffiche"
            class="text-left mt-2"
            style="max-width: 500px; margin: 0 auto;"
          >
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="h5 font-weight-bolder mb-0">Prélèvement mensuel</span>
              <b-badge :variant="mandatVariante">
                {{ mandatLibelle }}
              </b-badge>
            </div>
            <hr>

            <!-- À mettre en place, ou à reprendre -->
            <div v-if="etatMandat === 0 || etatMandat === 1 || etatMandat === -1">
              <p v-if="etatMandat === -1" class="text-muted">
                La mise en place de votre prélèvement n'a pas abouti. Vous pouvez
                la relancer : vos coordonnées bancaires seront saisies à nouveau,
                sur une page sécurisée.
              </p>
              <p v-else-if="etatMandat === 1" class="text-muted">
                Vous n'avez pas terminé la mise en place de votre prélèvement.
                Vous pouvez reprendre où vous en étiez.
              </p>
              <p v-else class="text-muted">
                Pour vos mensualités suivantes, autorisez le prélèvement
                automatique. Vous saisirez votre IBAN sur une page sécurisée :
                nous ne le conservons pas.
              </p>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                block
                :disabled="mandatChargement || mandatIndispo"
                @click="lancerMandat"
              >
                {{ mandatChargement ? 'Préparation...' : mandatLibelleBouton }}
              </b-button>
              <small v-if="mandatIndispo" class="text-muted d-block mt-1">
                Ce service est momentanément indisponible. Votre domiciliation
                reste active : nous vous recontacterons pour la mise en place
                du prélèvement.
              </small>
            </div>

            <!-- Mandat enregistré, présenté à la banque au premier prélèvement -->
            <div v-else-if="etatMandat === 2">
              <p class="text-muted mb-1">
                Votre mandat de prélèvement est enregistré. Il sera présenté à
                votre banque lors de la première mensualité : vous n'avez rien
                à faire.
              </p>
              <div v-if="mandatBanque" class="d-flex justify-content-between mb-50">
                <span>Banque</span>
                <strong>{{ mandatBanque }}</strong>
              </div>
              <div v-if="mandatIbanMasque" class="d-flex justify-content-between mb-50">
                <span>Compte</span>
                <strong>&bull;&bull;&bull;&bull; {{ mandatIbanMasque }}</strong>
              </div>
            </div>

            <!-- Mandat actif -->
            <div v-else-if="etatMandat === 3">
              <p class="text-muted mb-1">
                Votre prélèvement automatique est en place. Vos mensualités
                seront prélevées sur ce compte.
              </p>
              <div v-if="mandatBanque" class="d-flex justify-content-between mb-50">
                <span>Banque</span>
                <strong>{{ mandatBanque }}</strong>
              </div>
              <div v-if="mandatIbanMasque" class="d-flex justify-content-between mb-50">
                <span>Compte</span>
                <strong>&bull;&bull;&bull;&bull; {{ mandatIbanMasque }}</strong>
              </div>
              <div v-if="mandatRef" class="d-flex justify-content-between mb-50">
                <span>Référence du mandat</span>
                <strong>{{ mandatRef }}</strong>
              </div>
              <div v-if="mandatProchainPrelevement" class="d-flex justify-content-between mb-50">
                <span>Première échéance possible</span>
                <strong>{{ formatDateFr(mandatProchainPrelevement) }}</strong>
              </div>
            </div>
          </b-card>
        </div>
      </div>

      <!-- ========================================= -->
      <!-- Barre de progression                      -->
      <!-- ========================================= -->
      <b-card v-if="etapeencour > 0 && etapeencour < 8">
        <b-progress
          :max="maxetape"
          animated
          variant="secondary"
        >
          <b-progress-bar :value="etapeencour" class="demo-vertical-spacing" variant="primary">
            <strong>Etape {{ etapeencour }} sur {{ maxetape }}</strong>
          </b-progress-bar>
        </b-progress>
      </b-card>
      <small class="text-muted">{{ version_dom }} - Domicializ</small>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BProgress,
  BProgressBar,
  BImg,
  BRow,
  BCol,
  BFormInput,
  BFormCheckbox,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BCardGroup,
  BFormRadioGroup,
  BFormFile,
  BFormTextarea,
  BBadge,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { useRouter } from '@core/utils/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { StripeElementPayment } from '@vue-stripe/vue-stripe'

export default {
  components: {
    BCard,
    BButton,
    BProgress,
    BProgressBar,
    BImg,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BCardGroup,
    BFormRadioGroup,
    BFormFile,
    BFormTextarea,
    BBadge,
    BListGroup,
    BListGroupItem,
    vSelect,
    StripeElementPayment,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      version_dom: 'V1.0.0',
      etapeencour: 0,
      maxetape: 7,
      UIdemande: '',
      UISOC: '',
      demandeCreee: false,
      bcodeok: false,
      CCODE: '',

      // Étape 1 - Informations personnelles
      typeClient: '',
      situationPro: '',
      typeDemande: '',
      CNOM: '',
      CPRENOM: '',
      CPORT: '',
      CEMAIL: '',

      optionsTypeClient: [
        { text: 'Un particulier', value: 'particulier' },
        { text: 'Un professionnel', value: 'entreprise' },
        { text: 'Une association', value: 'association' },
      ],
      optionsSituation: [
        { text: 'Déjà en activité', value: 'activite' },
        { text: 'En cours de création', value: 'creation' },
      ],
      optionsTypeDemande: [
        { text: 'Établissement secondaire', value: 'etablissement_secondaire' },
        { text: 'Transfert de siège social', value: 'transfert_siege' },
      ],

      // Étape 2 - Choix de la formule
      facturation: 'mensuelle',
      formuleChoisie: null,
      optionsFacturation: [
        { text: 'Facturation mensuelle', value: 'mensuelle' },
        { text: 'Facturation annuelle', value: 'annuelle' },
      ],
      formules: [],
      libsoc: '',

      // Étape 3 - Informations établissement
      raisonSociale: '',
      formeJuridique: null,
      capitalSocial: '',
      objetSocial: '',
      codeAPE: '',
      activiteExercee: '',
      siret: '',
      rna: '',
      emailPro: '',
      telPro: '',
      aDesAssocies: false,
      associes: [],
      showPromo: false,
      codePromo: '',

      formesJuridiques: [],

      // Étape 4 - Représentant légal
      qualite: '',
      civiliteRL: null,
      prenomRL: '',
      nomRL: '',
      portableRL: '',
      emailRL: '',
      dateNaissance: '',
      villeNaissance: '',
      deptNaissance: '',
      paysNaissance: '',
      adresseRL: '',
      complementAdresse: '',
      cpRL: '',
      villeRL: '',
      paysRL: 'Réunion',
      residentFiscalEtranger: false,
      paysResidenceFiscale: '',
      personneExposee: false,
      commentaire: '',

      // Étape 4 (suite) - Localisation des archives
      archivesAdresse: '',
      archivesComplement: '',
      archivesCp: '',
      archivesVille: '',
      archivesPays: 'France',
      archivesTypeLieu: '',
      archivesTypeLieuAutre: '',
      archivesResponsable: '',
      archivesFonction: '',

      // Étape 4 (suite) - PPE détaillé (renseigné si personneExposee = true)
      ppeCategorie: '',
      ppeCategorieAutre: '',
      ppeLien: false,
      ppeLienType: '',
      ppeLienAutre: '',
      ppeLienNom: '',
      ppeLienFonction: '',
      ppeLienPays: '',

      // Étape 4 (suite) - Origine des fonds + risques (LCB-FT)
      origineFonds: '',
      origineFondsAutre: '',
      origineFondsPays: '',
      paysRisqueGafi: false,
      paysRisqueGafiPrecisions: '',
      gelAvoirs: false,
      gelAvoirsPrecisions: '',
      proceduresJudiciaires: false,
      proceduresJudiciairesPrecisions: '',

      // Étape 8 - Mandat de prélèvement SEPA GoCardless.
      // etatMandat suit TB_DOM_DEVIS.I_etatMandat : axe parallèle à I_etat,
      // qui reste terminal à 6. Null tant que le statut n'a pas été chargé,
      // pour ne pas afficher « à mettre en place » avant de savoir.
      etatMandat: null,
      mandatRef: '',
      mandatIbanMasque: '',
      mandatBanque: '',
      mandatMotif: '',
      mandatProchainPrelevement: '',
      mandatChargement: false,
      mandatIndispo: false,

      optionsArchivesTypeLieu: [
        { text: 'Local professionnel', value: 'localPro' },
        { text: 'Domicile du dirigeant', value: 'domicileDirigeant' },
        { text: 'Autre', value: 'autre' },
      ],
      optionsPpeCategorie: [
        { text: 'Chef d\'État, membre de gouvernement, parlementaire', value: 'chefEtat' },
        { text: 'Haut magistrat, militaire de haut rang', value: 'magistrat' },
        { text: 'Ambassadeur, cadre dirigeant d\'entreprise publique', value: 'ambassadeur' },
        { text: 'Membre de la direction d\'un parti politique', value: 'parti' },
        { text: 'Autre', value: 'autre' },
      ],
      optionsPpeLienType: [
        { text: 'Conjoint(e)', value: 'conjoint' },
        { text: 'Parent / enfant / frère / sœur', value: 'familleProche' },
        { text: 'Partenaire d\'affaires', value: 'associe' },
        { text: 'Autre', value: 'autre' },
      ],
      optionsOrigineFonds: [
        { text: 'Revenus professionnels', value: 'revenus' },
        { text: 'Épargne personnelle', value: 'epargne' },
        { text: 'Vente d\'actifs', value: 'venteActifs' },
        { text: 'Autre', value: 'autre' },
      ],

      civilites: [
        { name: 'Madame', id: '2' },
        { name: 'Monsieur', id: '4' },
      ],

      // Étape 5 - Pièces justificatives
      documentsRequis: [],
      documentsUploades: {},
      uploadEnCours: {},

      // Étape 6 - Relecture
      accepteDocuments: false,

      // Étape 7 - Paiement Stripe
      stripePret: false,
      stripeErreur: false,
      montantPaiement: '0.00',
      confirmParams: {
        return_url: '#',
      },
      elementsOptions: {
        appearance: {},
      },
      pk: '',
      documentsRelecture: [
        { label: 'Contrat de domiciliation', obligatoire: true, type: 'contrat' },
        { label: 'Procuration postale', obligatoire: true, type: 'procuration' },
        { label: 'Attestation sur l\'honneur du projet de création', obligatoire: true, type: 'attestation-creation' },
        { label: 'Attestation Personne Politiquement Exposée', obligatoire: true, type: 'attestation-ppe' },
        { label: 'Localisation de vos archives administratives et comptables', obligatoire: true, type: 'localisation-archives' },
      ],
    }
  },
  computed: {
    prixTTC() {
      if (!this.formuleChoisie) return '0.00'
      const prixHT = this.facturation === 'annuelle'
        ? this.formuleChoisie.prixAnnuelHT
        : this.formuleChoisie.prixMensuelHT
      return (prixHT * 1.085).toFixed(2)
    },
    // Dépôt de garantie : 1 mois pour un particulier, 2 mois sinon
    // (doit rester synchronisé avec le calcul backend dans /dom/secret).
    nbMoisDepot() {
      return this.typeClient === 'particulier' ? 1 : 2
    },
    depotGarantie() {
      if (!this.formuleChoisie) return '0.00'
      const prixHT = this.facturation === 'annuelle'
        ? this.formuleChoisie.prixAnnuelHT
        : this.formuleChoisie.prixMensuelHT
      return (prixHT * this.nbMoisDepot).toFixed(2)
    },
    totalTTC() {
      if (!this.formuleChoisie) return '0.00'
      const prixHT = this.facturation === 'annuelle'
        ? this.formuleChoisie.prixAnnuelHT
        : this.formuleChoisie.prixMensuelHT
      const mois1TTC = prixHT * 1.085
      const depot = prixHT * this.nbMoisDepot
      const frais = 20
      return (mois1TTC + depot + frais).toFixed(2)
    },
    // L'établissement secondaire n'est pas proposé aux associations.
    optionsTypeDemandeAffiche() {
      if (this.typeClient === 'association') {
        return this.optionsTypeDemande.filter(o => o.value !== 'etablissement_secondaire')
      }
      return this.optionsTypeDemande
    },
    // Nom de la société en Capitale initiale uniquement (ex. « Domicializ »).
    libsocAffiche() {
      if (!this.libsoc) return ''
      return this.libsoc.charAt(0).toUpperCase() + this.libsoc.slice(1).toLowerCase()
    },
    // Pour un particulier, on parle du « demandeur » et non d'un représentant légal.
    titreRepresentant() {
      return this.typeClient === 'particulier'
        ? 'Informations du demandeur'
        : 'Informations sur le représentant légal'
    },
    documentsPersonnels() {
      return this.documentsRequis.filter(d => d.categorie === 'personnel')
    },
    documentsProfessionnels() {
      return this.documentsRequis.filter(d => d.categorie === 'professionnel')
    },
    // Le badge promo n'est proposé qu'en facturation annuelle. On ne réserve la
    // ligne que si au moins une formule affichée en porte un (sinon espace perdu).
    afficherBadgePromoAnnuel() {
      return this.facturation === 'annuelle' && this.formules.some(f => f.badgeAnnuel)
    },

    // Le bloc mandat n'apparaît qu'une fois le statut chargé : afficher
    // « à mettre en place » avant de savoir ferait clignoter l'écran de
    // succès, et inviterait à relancer un mandat déjà en place.
    mandatAffiche() {
      return this.etatMandat !== null
    },
    // Libellés dérivés de I_etatMandat (voir sql/012).
    mandatLibelle() {
      if (this.etatMandat === 3) return 'En place'
      if (this.etatMandat === 2) return 'Enregistré'
      if (this.etatMandat === -1) return 'Échec'
      if (this.etatMandat === 1) return 'À terminer'
      return 'À mettre en place'
    },
    mandatVariante() {
      if (this.etatMandat === 3) return 'success'
      if (this.etatMandat === 2) return 'info'
      if (this.etatMandat === -1) return 'danger'
      return 'secondary'
    },
    mandatLibelleBouton() {
      if (this.etatMandat === -1) return 'Relancer la mise en place'
      if (this.etatMandat === 1) return 'Reprendre la mise en place'
      return 'Mettre en place mon prélèvement'
    },
    // Nom complet du représentant légal, utilisé pour le pré-remplissage des archives.
    nomCompletRepresentant() {
      return [this.prenomRL, this.nomRL].filter(v => v !== '').join(' ')
    },
    // La fonction n'a pas de sens quand les archives sont au domicile du dirigeant.
    archivesFonctionAffichee() {
      return this.archivesTypeLieu !== 'domicileDirigeant'
    },
    // La localisation des archives n'est pas demandée aux particuliers.
    documentsRelectureAffiche() {
      if (this.typeClient === 'particulier') {
        return this.documentsRelecture.filter(d => d.type !== 'localisation-archives')
      }
      return this.documentsRelecture
    },
  },
  watch: {
    etapeencour(val) {
      if (val === 4) {
        this.prefillRepresentant()
      }
      if (val === 5) {
        this.chargerDocumentsRequis()
        this.chargerDocumentsExistants()
      }
      if (val === 8) {
        this.chargerStatutMandat()
      }
    },
  },
  created() {
    // Référentiels chargés dans tous les cas
    this.chargerFormesJuridiques()
    this.chargerDocumentsRequis()

    if (this.routeName === 'dom2') {
      // Mode reprise : l'ID en URL est l'UI de la demande
      this.UIdemande = this.UI
      this.demandeCreee = true
      this.$http.get(`${this.APIURL}dom/getdemande/${this.UI}`)
        .then(response => {
          if (response.data.res === 1) {
            this.UISOC = response.data.UISOC
            this.libsoc = response.data.libelle
            this.remplirDemande(response.data)
            this.chargerFormules()
            // L'écran de succès n'est affiché que si le back a confirmé le paiement
            // auprès de Stripe (I_etat = 6) : le paramètre d'URL ne fait pas foi.
            this.etapeencour = this.resoudreEtape(response.data.I_etat, response.data.B_codeok)
            if (this.queryPaiement === 'ko') {
              this.showToast('votre paiement n\'a pas abouti, vous pouvez le relancer depuis cette page.')
            }
            // Retour de la page GoCardless. L'état réel vient de
            // /dom/mandat/statut, pas du paramètre d'URL : un mandat SEPA met
            // plusieurs jours ouvrés à devenir actif.
            if (this.queryMandat === 'abandon') {
              this.showToast('la mise en place du prélèvement a été interrompue, vous pouvez la reprendre depuis cette page.')
            }
          } else {
            this.showToast('Demande introuvable')
          }
        })
    } else {
      // Mode landing : l'ID en URL est l'UI de la société
      this.UISOC = this.UI
      this.etapeencour = 0
      this.chargerFormules()
    }
  },
  setup() {
    const { router } = useRouter()
    const UI = router.currentRoute.params.id
    const routeName = router.currentRoute.name
    const APIURL = process.env.VUE_APP_APIURL || 'https://api.reunibox.com/'
    const queryPaiement = router.currentRoute.query.paiement || ''
    const queryMandat = router.currentRoute.query.mandat || ''
    return {
      UI,
      routeName,
      APIURL,
      queryPaiement,
      queryMandat,
    }
  },
  methods: {
    getPrix(formule) {
      return this.facturation === 'annuelle'
        ? formule.prixAnnuelHT.toFixed(2)
        : formule.prixMensuelHT.toFixed(2)
    },

    validerEtape1() {
      if (this.typeClient === '') {
        this.showToast('Merci de sélectionner votre type de profil')
        return
      }
      const manquants = []
      if (this.CPRENOM === '') manquants.push('Prénom')
      if (this.CNOM === '') manquants.push('Nom')
      if (this.CPORT === '') manquants.push('Portable')
      if (this.CEMAIL === '') manquants.push('Adresse email')
      if (manquants.length) {
        this.showToast(`Merci de remplir : ${manquants.join(', ')}`)
        return
      }
      if (this.demandeCreee) {
        // Demande déjà créée, pas besoin de recréer
        return
      }
      this.$http.post(`${this.APIURL}dom/adddemande`, {
        UISOC: this.UISOC || this.UI,
        EMAIL: this.CEMAIL,
        PORT: this.CPORT,
        CNOM: this.CNOM,
        CPRENOM: this.CPRENOM,
        typeClient: this.typeClient,
        situationPro: this.situationPro,
        typeDemande: this.typeDemande,
      })
      .then(response => {
        if (response.data.res === 1) {
          this.UIdemande = response.data.UIdemande
          if (!this.UISOC) this.UISOC = this.UI
          this.demandeCreee = true
          window.history.replaceState(null, '', `/dom2/${this.UIdemande}`)
          this.chargerFormules()
        } else if (response.data.res === -3) {
          this.showToast(response.data.error || 'Configuration email manquante')
        } else {
          this.showToast('Erreur lors de la création de la demande')
        }
      })
    },

    chargerFormules() {
      if (!this.UISOC) return
      const params = this.typeClient
        ? { params: { typeClient: this.typeClient } }
        : {}
      this.$http.get(`${this.APIURL}dom/getformules/${this.UISOC}`, params)
        .then(response => {
          if (response.data.res === 1) {
            this.formules = response.data.ResultFormules
            this.libsoc = response.data.libelle
          } else {
            this.showToast('Erreur lors du chargement des formules')
          }
        })
    },

    chargerFormesJuridiques() {
      this.$http.get(`${this.APIURL}dom/getformesjuridiques`)
        .then(response => {
          if (response.data.res === 1) {
            this.formesJuridiques = response.data.ResultFormesJuridiques
          }
        })
    },

    chargerDocumentsRequis() {
      // Les pièces demandées dépendent du type de client et de la situation
      // (création vs déjà existant) — cf. backend /dom/getdocumentsrequis.
      const params = {}
      if (this.typeClient) params.typeClient = this.typeClient
      if (this.situationPro) params.situation = this.situationPro
      this.$http.get(`${this.APIURL}dom/getdocumentsrequis`, { params })
        .then(response => {
          if (response.data.res === 1) {
            this.documentsRequis = response.data.ResultDocuments
          }
        })
    },

    resoudreEtape(IEtat, BCodeok) {
      if (IEtat === 6) return 8
      if (IEtat === 4) return 6
      if (IEtat === 3) return 5
      if (IEtat === 2) return 4
      if (IEtat === 1) return 3
      if (BCodeok) return 2
      return 1
    },

    formatDateFr(valeur) {
      if (!valeur) return ''
      const d = new Date(valeur)
      if (Number.isNaN(d.getTime())) return String(valeur)
      return d.toLocaleDateString('fr-FR')
    },

    // ==========================================
    // Mandat de prélèvement SEPA (GoCardless)
    // ==========================================

    // État réel du mandat, lu côté serveur. Le paramètre ?mandat= de l'URL de
    // retour ne fait pas foi : au retour de la page hébergée, le mandat est au
    // mieux en attente de validation bancaire, et il peut échouer des jours
    // plus tard (c'est le webhook qui tranche).
    chargerStatutMandat() {
      if (!this.UIdemande) return
      this.$http.get(`${this.APIURL}dom/mandat/statut/${this.UIdemande}`)
        .then(response => {
          const { data } = response
          if (data.res !== 1) return
          this.etatMandat = data.etatMandat
          this.mandatRef = data.mandateRef || ''
          this.mandatIbanMasque = data.ibanMasque || ''
          this.mandatBanque = data.banque || ''
          this.mandatMotif = data.motif || ''
          this.mandatProchainPrelevement = data.prochainPrelevement || ''
        })
        .catch(() => {
          // Statut indisponible : on laisse le bloc masqué plutôt que
          // d'inviter à relancer un mandat dont on ignore l'état.
        })
    },

    lancerMandat() {
      this.mandatChargement = true
      this.$http.post(`${this.APIURL}dom/mandat/start`, { UIDEV: this.UIdemande })
        .then(response => {
          const { data } = response
          if (data.res === 1 && data.authorisationUrl) {
            // Redirection vers la page hébergée GoCardless, qui collecte et
            // valide l'IBAN. Le lien est périssable : on ne le mémorise pas
            // côté front, c'est le serveur qui décide d'en resservir un ou
            // d'en créer un neuf.
            window.location.href = data.authorisationUrl
            return
          }
          this.mandatChargement = false
          if (data.res === 1 && data.dejaEnPlace) {
            this.chargerStatutMandat()
            return
          }
          if (data.res === -2) this.mandatIndispo = true
          this.showToast(data.message || 'la mise en place du prélèvement est momentanément indisponible.')
        })
        .catch(() => {
          this.mandatChargement = false
          this.mandatIndispo = true
          this.showToast('la mise en place du prélèvement est momentanément indisponible.')
        })
    },

    remplirDemande(d) {
      this.CEMAIL = d.C_email || ''
      this.CPORT = d.C_port || ''
      this.CNOM = d.C_nom || ''
      this.CPRENOM = d.C_prenom || ''
      this.typeClient = d.C_typeClient || ''
      this.situationPro = d.C_situationPro || ''
      this.typeDemande = d.C_typeDemande || ''
      this.bcodeok = d.B_codeok === 1
      if (d.formuleChoisie) this.formuleChoisie = d.formuleChoisie
      this.facturation = d.C_facturation || 'mensuelle'
      this.raisonSociale = d.C_raisonSociale || ''
      this.formeJuridique = d.C_formeJuridique || null
      this.capitalSocial = d.C_capitalSocial || ''
      this.objetSocial = d.C_objetSocial || ''
      this.codeAPE = d.C_codeAPE || ''
      this.activiteExercee = d.C_activiteExercee || ''
      this.siret = d.C_siret || ''
      this.rna = d.C_rna || ''
      this.emailPro = d.C_emailPro || ''
      this.telPro = d.C_telPro || ''
      this.aDesAssocies = d.B_associes === 1
      this.associes = d.associes || []
      this.qualite = d.C_qualite || ''
      this.civiliteRL = d.C_civilite || null
      this.prenomRL = d.C_prenomRL || ''
      this.nomRL = d.C_nomRL || ''
      this.portableRL = d.C_portableRL || ''
      this.emailRL = d.C_emailRL || ''
      this.dateNaissance = d.D_dateNaissance || ''
      this.villeNaissance = d.C_villeNaissance || ''
      this.deptNaissance = d.C_deptNaissance || ''
      this.paysNaissance = d.C_paysNaissance || ''
      this.adresseRL = d.C_adresseRL || ''
      this.complementAdresse = d.C_complementAdresse || ''
      this.cpRL = d.C_cpRL || ''
      this.villeRL = d.C_villeRL || ''
      this.paysRL = d.C_paysRL || 'Réunion'
      this.residentFiscalEtranger = d.B_residentFiscalEtranger === 1
      this.paysResidenceFiscale = d.C_paysResidenceFiscale || ''
      this.personneExposee = d.B_personneExposee === 1
      this.commentaire = d.C_commentaire || ''
      this.codePromo = d.C_codePromo || ''
      // Localisation des archives
      this.archivesAdresse = d.C_archivesAdresse || ''
      this.archivesComplement = d.C_archivesComplement || ''
      this.archivesCp = d.C_archivesCp || ''
      this.archivesVille = d.C_archivesVille || ''
      this.archivesPays = d.C_archivesPays || 'France'
      this.archivesTypeLieu = d.C_archivesTypeLieu || ''
      this.archivesTypeLieuAutre = d.C_archivesTypeLieuAutre || ''
      this.archivesResponsable = d.C_archivesResponsable || ''
      this.archivesFonction = d.C_archivesFonction || ''
      // PPE détaillé
      this.ppeCategorie = d.C_ppeCategorie || ''
      this.ppeCategorieAutre = d.C_ppeCategorieAutre || ''
      this.ppeLien = d.B_ppeLien === 1
      this.ppeLienType = d.C_ppeLienType || ''
      this.ppeLienAutre = d.C_ppeLienAutre || ''
      this.ppeLienNom = d.C_ppeLienNom || ''
      this.ppeLienFonction = d.C_ppeLienFonction || ''
      this.ppeLienPays = d.C_ppeLienPays || ''
      this.origineFonds = d.C_origineFonds || ''
      this.origineFondsAutre = d.C_origineFondsAutre || ''
      this.origineFondsPays = d.C_origineFondsPays || ''
      this.paysRisqueGafi = d.B_paysRisqueGafi === 1
      this.paysRisqueGafiPrecisions = d.C_paysRisqueGafiPrecisions || ''
      this.gelAvoirs = d.B_gelAvoirs === 1
      this.gelAvoirsPrecisions = d.C_gelAvoirsPrecisions || ''
      this.proceduresJudiciaires = d.B_proceduresJudiciaires === 1
      this.proceduresJudiciairesPrecisions = d.C_proceduresJudiciairesPrecisions || ''
    },

    sendcode() {
      this.bcodeok = false
      this.$http.post(`${this.APIURL}dom/sendcode`, {
        UI: this.UIdemande,
        UISOC: this.UISOC,
        EMAIL: this.CEMAIL,
      })
      .then(response => {
        if (response.data.res === 1) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'OK',
              icon: 'SmileIcon',
              variant: 'primary',
              text: 'Le code a été renvoyé',
            },
          },
          {
            timeout: 4000,
            position: 'top-center',
          })
        } else if (response.data.res === -3) {
          this.showToast(response.data.error || 'Configuration email manquante')
        } else {
          this.showToast('Erreur lors de l\'envoi du code')
        }
      })
    },

    verifcode() {
      this.bcodeok = false
      this.$http.post(`${this.APIURL}dom/verifcode`, {
        UI: this.UIdemande,
        code: this.CCODE,
      })
      .then(response => {
        if (response.data.res === 1) {
          if (response.data.etat === 1) {
            this.bcodeok = true
            // Email validé : on enchaîne directement sur le choix de l'offre
            this.etapeencour = 2
          } else {
            this.showToast('Le code est incorrect')
          }
        } else {
          this.showToast('Erreur de connexion au serveur')
        }
      })
    },

    souscrireFormule(formule) {
      this.formuleChoisie = formule
      this.$http.post(`${this.APIURL}dom/majdemande/formule`, {
        UIDEV: this.UIdemande,
        ID_dom_formule: formule.ID_dom_formule,
        C_facturation: this.facturation,
      })
      .then(response => {
        if (response.data.res === 1) {
          if (this.typeClient === 'particulier') {
            // Pas d'établissement à domicilier pour un particulier :
            // on saute l'étape 3 et on passe directement au demandeur.
            this.skipEtablissementParticulier()
          } else {
            this.etapeencour = 3
          }
        } else {
          this.showToast('Erreur lors de la sauvegarde de la formule')
        }
      })
    },

    // Pour un particulier, on enregistre une fiche établissement minimale
    // (nom du demandeur en « raison sociale ») afin de faire progresser
    // l'état du dossier (I_etat=2) et de garder un parcours reprenable.
    skipEtablissementParticulier() {
      this.$http.post(`${this.APIURL}dom/majdemande/etablissement`, {
        UIDEV: this.UIdemande,
        C_raisonSociale: `${this.CPRENOM} ${this.CNOM}`.trim(),
        C_formeJuridique: '',
        C_capitalSocial: '',
        C_objetSocial: '',
        C_codeAPE: '',
        C_activiteExercee: '',
        C_siret: '',
        C_rna: '',
        C_emailPro: '',
        C_telPro: '',
        B_associes: false,
        C_codePromo: this.codePromo,
        associes: [],
      })
      .then(response => {
        if (response.data.res === 1) {
          this.etapeencour = 4
        } else {
          this.showToast('Erreur lors de la sauvegarde de la demande')
        }
      })
    },

    // Pré-remplit la fiche demandeur/représentant avec les informations
    // saisies à l'étape 1 si elles ne sont pas déjà renseignées.
    prefillRepresentant() {
      if (!this.prenomRL) this.prenomRL = this.CPRENOM
      if (!this.nomRL) this.nomRL = this.CNOM
      if (!this.portableRL) this.portableRL = this.CPORT
      if (!this.emailRL) this.emailRL = this.CEMAIL
    },

    // « Domicile du dirigeant » : on recopie l'adresse personnelle et le nom du
    // représentant légal saisis plus haut. Si l'utilisateur change ensuite de type
    // de lieu, on ne vide que les valeurs qu'il n'a pas retouchées.
    onChangeArchivesTypeLieu(val) {
      if (val === 'domicileDirigeant') {
        this.archivesAdresse = this.adresseRL
        this.archivesComplement = this.complementAdresse
        this.archivesCp = this.cpRL
        this.archivesVille = this.villeRL
        this.archivesPays = this.paysRL || 'France'
        this.archivesResponsable = this.nomCompletRepresentant
        this.archivesFonction = ''
        return
      }
      if (this.archivesAdresse === this.adresseRL) this.archivesAdresse = ''
      if (this.archivesComplement === this.complementAdresse) this.archivesComplement = ''
      if (this.archivesCp === this.cpRL) this.archivesCp = ''
      if (this.archivesVille === this.villeRL) this.archivesVille = ''
      if (this.archivesResponsable === this.nomCompletRepresentant) this.archivesResponsable = ''
    },

    validerEtape3() {
      const manquants = []
      if (this.raisonSociale === '') manquants.push('Raison sociale')
      if (this.formeJuridique === null) manquants.push('Forme juridique')
      if (this.capitalSocial === '') manquants.push('Capital social')
      if (this.typeClient === 'entreprise' && this.situationPro === 'activite' && this.siret === '') {
        manquants.push('SIRET')
      }
      if (this.typeClient === 'association' && this.situationPro === 'activite' && this.rna === '') {
        manquants.push('N° RNA')
      }
      if (manquants.length) {
        this.showToast(`Merci de remplir : ${manquants.join(', ')}`)
        return
      }
      this.$http.post(`${this.APIURL}dom/majdemande/etablissement`, {
        UIDEV: this.UIdemande,
        C_raisonSociale: this.raisonSociale,
        C_formeJuridique: this.formeJuridique ? this.formeJuridique.name : '',
        C_capitalSocial: this.capitalSocial,
        C_objetSocial: this.objetSocial,
        C_codeAPE: this.codeAPE,
        C_activiteExercee: this.activiteExercee,
        C_siret: this.siret,
        C_rna: this.rna,
        C_emailPro: this.emailPro,
        C_telPro: this.telPro,
        B_associes: this.aDesAssocies,
        C_codePromo: this.codePromo,
        associes: this.associes,
      })
      .then(response => {
        if (response.data.res === 1) {
          this.etapeencour = 4
        } else {
          this.showToast('Erreur lors de la sauvegarde des informations')
        }
      })
    },

    validerEtape4() {
      const manquants = []
      if (this.qualite === '') manquants.push('Qualité')
      if (this.civiliteRL === null) manquants.push('Civilité')
      if (this.prenomRL === '') manquants.push('Prénom')
      if (this.nomRL === '') manquants.push('Nom')
      if (this.portableRL === '') manquants.push('Portable')
      if (this.emailRL === '') manquants.push('Email')
      if (this.dateNaissance === '') manquants.push('Date de naissance')
      if (this.villeNaissance === '') manquants.push('Ville de naissance')
      if (this.adresseRL === '') manquants.push('Adresse')
      if (this.cpRL === '') manquants.push('Code postal')
      if (this.villeRL === '') manquants.push('Ville')
      if (manquants.length) {
        this.showToast(`Merci de remplir : ${manquants.join(', ')}`)
        return
      }
      this.$http.post(`${this.APIURL}dom/majdemande/representant`, {
        UIDEV: this.UIdemande,
        C_qualite: this.qualite,
        C_civilite: this.civiliteRL ? this.civiliteRL.name : '',
        C_prenomRL: this.prenomRL,
        C_nomRL: this.nomRL,
        C_portableRL: this.portableRL,
        C_emailRL: this.emailRL,
        D_dateNaissance: this.dateNaissance,
        C_villeNaissance: this.villeNaissance,
        C_deptNaissance: this.deptNaissance,
        C_paysNaissance: this.paysNaissance,
        C_adresseRL: this.adresseRL,
        C_complementAdresse: this.complementAdresse,
        C_cpRL: this.cpRL,
        C_villeRL: this.villeRL,
        C_paysRL: this.paysRL,
        B_residentFiscalEtranger: this.residentFiscalEtranger,
        C_paysResidenceFiscale: this.paysResidenceFiscale,
        B_personneExposee: this.personneExposee,
        C_commentaire: this.commentaire,
        C_archivesAdresse: this.archivesAdresse,
        C_archivesComplement: this.archivesComplement,
        C_archivesCp: this.archivesCp,
        C_archivesVille: this.archivesVille,
        C_archivesPays: this.archivesPays,
        C_archivesTypeLieu: this.archivesTypeLieu,
        C_archivesTypeLieuAutre: this.archivesTypeLieuAutre,
        C_archivesResponsable: this.archivesResponsable,
        C_archivesFonction: this.archivesFonctionAffichee ? this.archivesFonction : '',
        C_ppeCategorie: this.ppeCategorie,
        C_ppeCategorieAutre: this.ppeCategorieAutre,
        B_ppeLien: this.ppeLien,
        C_ppeLienType: this.ppeLienType,
        C_ppeLienAutre: this.ppeLienAutre,
        C_ppeLienNom: this.ppeLienNom,
        C_ppeLienFonction: this.ppeLienFonction,
        C_ppeLienPays: this.ppeLienPays,
        C_origineFonds: this.origineFonds,
        C_origineFondsAutre: this.origineFondsAutre,
        C_origineFondsPays: this.origineFondsPays,
        B_paysRisqueGafi: this.paysRisqueGafi,
        C_paysRisqueGafiPrecisions: this.paysRisqueGafiPrecisions,
        B_gelAvoirs: this.gelAvoirs,
        C_gelAvoirsPrecisions: this.gelAvoirsPrecisions,
        B_proceduresJudiciaires: this.proceduresJudiciaires,
        C_proceduresJudiciairesPrecisions: this.proceduresJudiciairesPrecisions,
      })
      .then(response => {
        if (response.data.res === 1) {
          this.etapeencour = 5
        } else {
          this.showToast('Erreur lors de la sauvegarde des informations')
        }
      })
    },

    uploadDocument(docUI, file) {
      if (!file) return
      this.$set(this.uploadEnCours, docUI, true)
      const formData = new FormData()
      formData.append('file', file)
      formData.append('C_UIDocumentRequis', docUI)
      this.$http.post(`${this.APIURL}dom/uploaddocument/${this.UIdemande}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(response => {
        this.$set(this.uploadEnCours, docUI, false)
        if (response.data.res === 1) {
          this.$set(this.documentsUploades, docUI, response.data.document)
        } else {
          this.showToast(response.data.message || 'Erreur lors de l\'upload')
        }
      })
      .catch(() => {
        this.$set(this.uploadEnCours, docUI, false)
        this.showToast('Erreur lors de l\'upload du fichier')
      })
    },

    supprimerDocument(docUI) {
      const doc = this.documentsUploades[docUI]
      if (!doc) return
      this.$http.post(`${this.APIURL}dom/deletedocument`, { UIDocument: doc.UI })
      .then(response => {
        if (response.data.res === 1) {
          this.$delete(this.documentsUploades, docUI)
        }
      })
    },

    chargerDocumentsExistants() {
      if (!this.UIdemande) return
      this.$http.get(`${this.APIURL}dom/getdocuments/${this.UIdemande}`)
      .then(response => {
        if (response.data.res === 1) {
          response.data.documents.forEach(doc => {
            this.$set(this.documentsUploades, doc.C_UIDocumentRequis, doc)
          })
        }
      })
    },

    formatTaille(octets) {
      if (octets < 1024) return `${octets} o`
      if (octets < 1024 * 1024) return `${(octets / 1024).toFixed(1)} Ko`
      return `${(octets / (1024 * 1024)).toFixed(1)} Mo`
    },

    validerEtape5() {
      const docsObligatoires = this.documentsRequis.filter(d => d.obligatoire)
      const manquants = docsObligatoires.filter(d => !this.documentsUploades[d.UI])
      if (manquants.length > 0) {
        this.showToast(`Merci de fournir les pièces justificatives obligatoires : ${manquants.map(d => d.libelle).join(', ')}`)
        return
      }
      // Valider l'étape côté serveur
      this.$http.post(`${this.APIURL}dom/validerDocuments`, { UIDEV: this.UIdemande })
      .then(response => {
        if (response.data.res === 1) {
          this.etapeencour = 6
        } else {
          this.showToast('Erreur lors de la validation des documents')
        }
      })
    },

    ouvrirDocument(doc) {
      const url = `${this.APIURL}dom/genererPdf/${this.UIdemande}/${doc.type}`
      window.open(url, '_blank')
    },

    payerEtSigner() {
      this.etapeencour = 7
      this.preparerPaiement()
    },

    preparerPaiement() {
      this.stripePret = false
      this.stripeErreur = false
      this.$http.post(`${this.APIURL}dom/secret`, { UIDEV: this.UIdemande })
      .then(response => {
        if (response.data.res === 1) {
          this.confirmParams.return_url = response.data.urlretour
          this.elementsOptions.clientSecret = response.data.paymentIntent.client_secret
          this.pk = response.data.pk
          this.montantPaiement = (response.data.paymentIntent.amount / 100).toFixed(2)
          this.stripePret = true
        } else {
          this.stripeErreur = true
          this.showToast('Erreur lors de la préparation du paiement')
        }
      })
      .catch(() => {
        this.stripeErreur = true
        this.showToast('Erreur de connexion au serveur')
      })
    },

    pay() {
      this.$refs.paymentRef.submit()
    },

    showToast(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Oups',
          icon: 'AlertCircleIcon',
          variant: 'primary',
          text: `Erreur : ${message}`,
        },
      },
      {
        timeout: 4000,
        position: 'top-center',
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style lang="scss">
// Charte DOMICIALIZ : vert #AAE7C0 en couleur d'accent,
// rose #FC345C pour les boutons / actions principales.
.dom-parcours {
  $dom-vert: #aae7c0;
  $dom-vert-fonce: #0b3d24;
  $dom-vert-texte: #395f52;
  $dom-rose: #fc345c;
  $dom-rose-fonce: #e0264c;

  // Boutons d'action principaux en rose
  .btn-primary,
  .btn-primary:focus {
    background-color: $dom-rose !important;
    border-color: $dom-rose !important;
    color: #fff !important;
  }
  .btn-primary:hover,
  .btn-primary:active,
  .btn-primary.active {
    background-color: $dom-rose-fonce !important;
    border-color: $dom-rose-fonce !important;
  }

  // Boutons de sélection (radios « Vous êtes », oui/non, « Précédent »…) en vert.
  // Seuls les CTA solides (.btn-primary) restent roses.
  .btn-outline-primary {
    border-color: $dom-vert !important;
    color: $dom-vert-texte !important;
  }
  .btn-outline-primary:hover,
  .btn-outline-primary.active,
  .btn-outline-primary:active {
    background-color: $dom-vert !important;
    border-color: $dom-vert !important;
    color: $dom-vert-fonce !important;
  }

  // Accents verts : badges, bordures de cartes, barre de progression
  .badge-primary {
    background-color: $dom-vert !important;
    color: $dom-vert-fonce !important;
  }
  .border-primary {
    border-color: $dom-vert !important;
  }
  .progress .progress-bar {
    background-color: $dom-vert !important;
    color: $dom-vert-fonce !important;
  }

  // Montants / totaux mis en avant : rose lisible (le vert serait trop clair)
  .text-primary {
    color: $dom-rose !important;
  }

  // Titres mis en vert clair (à la demande du client)
  .dom-titre-vert {
    color: $dom-vert !important;
  }

  // Cartes de formules (étape 2)
  .dom-formule-badge {
    min-height: 1.75rem;
  }
  .dom-formule-titre {
    min-height: 4.25rem;
  }
  .dom-formule-pack {
    font-size: 1.7rem;
    line-height: 1.2;
    color: $dom-vert !important;
  }
  .dom-formule-benefice {
    font-size: 0.9rem;
    line-height: 1.2;
  }
  .dom-formule-prix {
    color: $dom-vert-texte !important;
  }
  // Badge promo « facturation annuelle » : rose pour se distinguer du badge
  // vert « Le + complet ». Hauteur réservée pour garder les cartes alignées.
  .dom-formule-promo {
    min-height: 1.5rem;
  }
  .dom-badge-promo {
    background-color: $dom-rose !important;
    color: #fff !important;
    font-size: 0.8rem;
  }
}
</style>
